export const IS_CLICK_OUTSIDE = 'isClickOutside:true';